/**
 * i18n for the admin SPA.
 *
 * ru is the default AND the fallback for every missing key. tk → ru, en → ru, and a missing
 * key anywhere resolves to the Russian string (docs/06 §8). Merdan works in Russian, so RU is
 * the bundle that is guaranteed complete; EN and TK degrade to it silently rather than
 * rendering a raw key.
 *
 * The keys are namespaced by area (`common`, `nav`, `status`, `dashboard`, …) inside a single
 * `admin` namespace, following the `area.screen.element` scheme.
 */
import { createI18n } from '@most/i18n';
import { ru } from './locales/ru';
import { en } from './locales/en';
import { tk } from './locales/tk';

export const i18n = createI18n({
  resources: {
    ru: { admin: ru },
    en: { admin: en },
    tk: { admin: tk },
  },
  defaultNS: 'admin',
});

export { ru, en, tk };
